import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ProductoMontoService } from '../../../_services/producto-monto.service';
import { NavService } from '../../../_services/_nav.service';
import { ConfirmationService } from 'primeng/api';
import { Producto } from '../../../_models/producto';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ProductoMonto } from '../../../_models/producto-monto';
import { Location } from '@angular/common';
import { ComunicationComponentsService } from '../../../_services/comunication-components.service';
import { Subscription } from 'rxjs';

@Component( {
  selector: 'app-producto-monto',
  templateUrl: 'producto-monto.component.html'
} )

export class ProductoMontoComponent implements OnInit, OnDestroy {

  @Input() producto: Producto;
  carInformacionInicial = true;
  lisProductosMontos: ProductoMonto[] = [];
  formulario: FormGroup;
  submitted = false;
  guardando = false;
  columnas: any[];
  ranIncorrecto = false;
  private updateSubscription: Subscription;
  rangoPlazoIncorrecto = false;
  exiIndicador = false;

  constructor( private proMontoServicio: ProductoMontoService,
               private navServicio: NavService,
               private location: Location,
               private fb: FormBuilder,
               private conServicio: ConfirmationService,
               private commService: ComunicationComponentsService ) {
  }

  ngOnInit(): void {
    this.updateSubscription = this.commService.primerComponent$.subscribe( prodData => {
      this.producto = prodData;
    } );

    this.columnas = [
      { field: 'rango', header: this.navServicio.buscarMensaje( 'PRODUCTOMONTO.LBL_RANGOMONTO' ), sort: false },
      { field: 'plazoMaximo', header: this.navServicio.buscarMensaje( 'PRODUCTOMONTO.LBL_PLAZOMAXIMO' ), sort: false },
      {
        field: 'plazoMaximoGarantiaIdonea',
        header: this.navServicio.buscarMensaje( 'PRODUCTOMONTO.LBL_PLAXOMAXIMOGARANTIAMESES' ),
        sort: false
      },
      { field: 'indicadorAnalizamos', header: this.navServicio.buscarMensaje( 'PRODUCTOMONTO.LBL_INDICADORANALIZAMOS' ), sort: false },
      { field: 'indicadorFlujoDigital', header: this.navServicio.buscarMensaje( 'PRODUCTOMONTO.LBL_INDICADORDIGITAL' ), sort: false },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    this.proMontoServicio.listadoPorProducto( this.producto.idProducto ).subscribe( lisProductosMontos => {
      this.lisProductosMontos = lisProductosMontos;
      this.ordenarListado(this.lisProductosMontos);
      this.cargarFormulario();
      this.carInformacionInicial = false;
    } );
  }

  ngOnDestroy(): void {
    if ( this.updateSubscription != null ) {
      this.updateSubscription.unsubscribe();
    }
  }

  ordenarListado(listado: ProductoMonto[]){
    listado.sort( function( a, b ) {
      if ( Number(a.montoMaximo) < Number(b.montoMaximo) ) {
        return -1;
      } else {
        return 1;
      }
    } );
    let maxAnalizamos = null;
    let maxDigital = null;
    listado.forEach(e => {
      e.indicadorEliminar = false;
      if (e.indicadorAnalizamos) {
        maxAnalizamos = this.validarMaximoIndicador(maxAnalizamos, e, 'indicadorAnalizamos');
      } else {
        maxDigital = this.validarMaximoIndicador(maxDigital, e, 'indicadorFlujoDigital');
      }
    });
  }

  validarMaximoIndicador(maximo: ProductoMonto, e: ProductoMonto, key: string){
    if(e[key] && (!maximo || Number(e.montoMaximo) > Number(maximo.montoMaximo))){
      if(maximo){
        maximo.indicadorEliminar = false;
      }
      maximo = e;
      maximo.indicadorEliminar = true;
    }
    return maximo;
  }

  cargarFormulario() {
    const maximo = this.obtenerMaximo( this.lisProductosMontos, true, false );
    this.formulario = this.fb.group( {
      idProductoMonto: [ null ],
      idProducto: [ this.producto.idProducto, [ Validators.required ] ],
      montoMinimo: [ maximo, [ Validators.required, Validators.maxLength( 9 ) ] ],
      montoMaximo: [ null, [ Validators.required, Validators.maxLength( 9 ) ] ],
      plazoMaximo: [ null, [ Validators.required, Validators.maxLength( 3 ) ] ],
      indicadorGarantiaIdonea: [ false, [] ],
      indicadorAnalizamos: [ true, [] ],
      indicadorFlujoDigital: [ false, [] ],
      plazoMaximoGarantiaIdonea: [ null, [] ],
      indicadorHabilitado: [ true ],
      auditoriaUsuario: [ null ],
      auditoriaFecha: [ null ],
    } );
    this.exiIndicador = true;
  }

  get f() {
    return this.formulario.controls;
  }

  inhabilitar( proMontos: ProductoMonto ) {

    if ( this.producto.indicadorHabilitado && this.lisProductosMontos.length == 1 ) {
      this.navServicio.setMesage( 0, {
        severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.navServicio.buscarMensaje( 'PRODUCTO.MSG_NOINHABILITAR' )
      } );
    } else {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_INHABILITAR' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'montos',
        accept: () => {
          this.carInformacionInicial = true;
          proMontos.indicadorHabilitado = false;
          this.proMontoServicio.actualizar( proMontos ).subscribe( regActualizado => {
            const a = this.lisProductosMontos.findIndex( x => x.idProductoMonto === proMontos.idProductoMonto );
            if ( a >= 0 ) {
              this.lisProductosMontos.splice( a, 1 );
            }
            this.ordenarListado(this.lisProductosMontos);
            const maximo = this.obtenerMaximo( this.lisProductosMontos, !!this.f.indicadorAnalizamos.value, !!this.f.indicadorFlujoDigital.value );
            this.f.montoMinimo.setValue( maximo );
            this.validarMaximoBorrar();
            this.carInformacionInicial = false;
          } );
        },
        reject: () => {
        }
      } );
    }

  }

  validarMaximoBorrar() {
    if ( this.f.montoMinimo.value && ( this.f.montoMaximo.value || this.f.montoMaximo.value === 0 ) && Number( this.f.montoMaximo.value ) <= this.f.montoMinimo.value ) {
      this.f.montoMaximo.setValue( null );
    }
  }

  regresar() {
    this.location.back();
  }

  onSubmit() {
    this.submitted = true;
    this.validarRango();
    this.validarRangoPlazo();
    if ( this.formulario.valid && !this.ranIncorrecto && !this.rangoPlazoIncorrecto ) {
      this.guardando = true;
      const proMonto = this.formulario.value;
      this.proMontoServicio.crear( proMonto ).subscribe( monto => {
        proMonto.idProductoMonto = monto.idProductoMonto;
        this.lisProductosMontos = [ ...this.lisProductosMontos, proMonto ];
        this.ordenarListado(this.lisProductosMontos);
        // this.lisProductosMontos.push(proMonto);
        this.f.plazoMaximoGarantiaIdonea.setValidators( [] );
        this.formulario.reset();
        this.f.idProducto.setValue( this.producto.idProducto );
        this.f.indicadorHabilitado.setValue( true );
        this.f.indicadorGarantiaIdonea.setValue( false );
        this.f.indicadorAnalizamos.setValue( true );
        this.f.indicadorFlujoDigital.setValue( false );
        this.submitted = false;
        this.exiIndicador = true;
        const maximo = this.obtenerMaximo( this.lisProductosMontos, true, false );
        this.f.montoMinimo.setValue( maximo  );
        this.guardando = false;
        this.navServicio.setMesage( 1 );
      }, error => {
        this.guardando = false;
        this.navServicio.setMesage( 3 );
      } );
    }
  }

  validarRango() {
    const inferior = this.f.montoMinimo.value;
    const superior = this.f.montoMaximo.value;
    const rangoMaximoProducto = this.producto.montoMaximo;
    const valMaxima = Number( superior ) > Number( rangoMaximoProducto );
    this.ranIncorrecto = ( inferior && superior && Number( inferior ) >= Number( superior ) ) || ( inferior && superior && valMaxima ) ? true : false;
  }

  validarRangoPlazo() {
    const plazoMaximo = this.f.plazoMaximo.value;
    const plazoMinimoProducto = this.producto.plazoMinimo;
    const plazoMaximoProducto = this.producto.plazoMaximo;
    const valMinima = Number( plazoMaximo ) < Number( plazoMinimoProducto );
    const valMaxima = Number( plazoMaximo ) > Number( plazoMaximoProducto );
    this.rangoPlazoIncorrecto = ( plazoMaximo && ( valMinima || valMaxima ) ) ? true : false;
  }

  obtenerMaximo( listado: ProductoMonto[], analizamos: boolean, flujo: boolean ): number {
    if ( !analizamos && !flujo ) {
      return null;
    }
    let maximo = 0;
    listado.map( ( s: ProductoMonto ) => {
      const a = Number( s.montoMaximo );
      if ( a > maximo && ( ( s.indicadorAnalizamos && analizamos ) || ( s.indicadorFlujoDigital && flujo ) ) ) {
        maximo = a;
      }
    } );
    return maximo;
  }

  cambioGarantia( valor: boolean ) {
    this.f.plazoMaximoGarantiaIdonea.setValidators( valor ? [ Validators.required ] : [] );
    this.f.plazoMaximoGarantiaIdonea.setValue( null );
  }

  cambioIndicador(analizamos: boolean) {
    if ( analizamos ) {
      this.f.indicadorFlujoDigital.setValue(false);
    } else {
      this.f.indicadorAnalizamos.setValue(false);
    }
    this.exiIndicador = !!this.f.indicadorAnalizamos.value || !!this.f.indicadorFlujoDigital.value;
    const maximo = this.obtenerMaximo( this.lisProductosMontos, !!this.f.indicadorAnalizamos.value, !!this.f.indicadorFlujoDigital.value );
    this.f.montoMinimo.setValue( maximo );
    this.validarMaximoBorrar();
  }

}
